import { Button } from '@design/components/buttons/button/Button'
import { Link, useRouter } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function Error404Screen({ rootUrl }: { rootUrl: string }) {
  const { history } = useRouter()
  const { t } = useTranslation()

  return (
    <div className='h-svh'>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
        <h1 className='font-bold text-[7rem] leading-tight'>404</h1>
        <span className='font-medium'>
          {t('designSystem.components.ui.pageNotFound')}
        </span>
        <p className='text-center text-muted-foreground'>
          It seems like the page you're looking for <br />
          does not exist or might have been removed.
        </p>
        <div className='mt-6 flex gap-4'>
          <Button variant='outline' onClick={() => history.go(-1)}>
            Go Back
          </Button>
          <Button asChild>
            <Link to={rootUrl}>
              {t('designSystem.components.ui.backToHome')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
